var hasNonDigitCharacters = function (value) {
  if (value === void 0) {
    value = '';
  }

  return /[^0-9]/.test(value);
};
var getSumOfMultiplcicationResults = function (numbers, coefficients) {
  return numbers.reduce(function (sum, value, i) {
    var multiplicationResult = Number.parseInt(value, 10) * coefficients[i];
    sum += multiplicationResult;
    return sum;
  }, 0);
};

export { getSumOfMultiplcicationResults, hasNonDigitCharacters };
